import { ActionButton } from './ActionButton';
import { DetailTranslationKeys } from '../../../api/models/TranslationKeys';
import { Log, Utils } from '@lightningjs/sdk';
import { ToggleReminderAction } from '../../../Business/detail/actions/ToggleReminderAction';
import { AssetType } from '../../../api/models/Shared.types';

export class ReminderActionButton extends ActionButton {
  private _type?: AssetType;
  private _id?: string;
  private _reminderState = false;

  override _init() {
    // this.label
    if (!this._id || !this._type) return Log.error('[ReminderActionButton]', 'missing id or type');
    this.actionHandler = new ToggleReminderAction(this._backend, this._id, this._type, (val: boolean) => {
      this.reminderState = val;
      this.labelState = val;
    });
  }

  set labelState(val: boolean) {
    this.label = val
      ? this._backend.translations.forKey(DetailTranslationKeys.detail_btn_remove_reminder)
      : this._backend.translations.forKey(DetailTranslationKeys.detail_btn_set_reminder);
  }

  set reminderState(val: boolean) {
    this._reminderState = val;
    if (val) {
      this.iconRight = Utils.asset('images/reminders/ic_reminder.png');
    } else {
      this.iconRight = undefined;
    }
  }

  set assetId(val: string) {
    this._id = val;
  }

  set assetType(val: AssetType) {
    this._type = val;
  }
}
